import React from "react";
import "./Developer.css";
function NetworkDetail() {
  return (
    <>
      <section className="content-section">
        <div className="row content-row">
          <div className="col-lg-12">
            <div className="content-head">
              <h1>NetworkDetails</h1>
            </div>
            <div className="Network-form">
              <input
                type="text"
                className="form-control"
                placeholder="Gaming Arcade Mainnet"
              />
              <input
                type="text"
                className="form-control"
                placeholder="Gaming Arcade Testnet"
              />
              <input
                type="text"
                className="form-control"
                placeholder="Token List"
              />
              <input
                type="text"
                className="form-control"
                placeholder="Help Build In contracts"
              />
              <input
                type="text"
                className="form-control"
                placeholder="Full Node Development"
              />
            </div>
            <div className="footer-bottom">
              <div className="footer-bottom-text">
                <p>Next</p>
                <h6>Wallets</h6>
              </div>
              <div className="footer-bottom-image">
                <img src={require("../../Assets/img/foot-arrow.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NetworkDetail;
